import type { OTCDealData } from '@src/types/OTC';
import type { ColumnDef } from '@talos/kyoko';
import type { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { getProductTemplateBlotterDisplayValue } from './getProductTemplateBlotterTooltipValue';
import { ProductTemplateBlotterCell } from './ProductTemplateBlotterCell';

export function getProductTemplateBlotterColumn({ description }: { description: string }): ColumnDef<OTCDealData> {
  return {
    field: 'TemplateSymbol',
    type: 'custom',
    title: 'Product Template',
    initialWidth: 180,
    description,
    // `description` still drives the header tooltip via baseColumn. Returning undefined here
    // keeps AG Grid from also showing a cell tooltip on top of the product-template popover.
    tooltipValueGetter: () => undefined,
    // Same class wrapColumnWithExcelColumnClass applies to text column types.
    cellClass: 'excel-text-column',
    params: {
      valueGetter: (params: ValueGetterParams<OTCDealData>) => getProductTemplateBlotterDisplayValue(params),
      // AgGridText only renders valueFormatted; custom columns do not get text()'s formatter.
      valueFormatter: (params: ValueFormatterParams<OTCDealData>) => params.value ?? '',
      cellRenderer: ProductTemplateBlotterCell,
      cellRendererParams: {
        columnParams: {},
      },
    },
  };
}
